import React, { Fragment, useState} from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn, faMagnifyingGlass, faHand } from '@fortawesome/free-solid-svg-icons'
import '../../styles/diario.scss';


function OuvidHome() {
    const [direct, setDirect] = useState(false);

    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/comopedir')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBullhorn} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Como Fazer uma Requisição</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/comoacompanhar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faMagnifyingGlass} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Como Consultar uma Requisição</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/ouvidoria/recurso')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faHand} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Como abrir um recurso</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Link to={'/ouvidoria'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
                </Container>
            </Fragment>
        );
    }
}

export default OuvidHome;